import { render, staticRenderFns } from "./HowWeWork.vue?vue&type=template&id=523e2d68&scoped=true"
import script from "./HowWeWork.vue?vue&type=script&lang=js"
export * from "./HowWeWork.vue?vue&type=script&lang=js"
import style0 from "./HowWeWork.vue?vue&type=style&index=0&id=523e2d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e2d68",
  null
  
)

export default component.exports